import { render } from "./salary_admin.vue?vue&type=template&id=46a52c3a"
import script from "./salary_admin.vue?vue&type=script&lang=js"
export * from "./salary_admin.vue?vue&type=script&lang=js"

import "./salary_admin.vue?vue&type=style&index=0&id=46a52c3a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__